const carouselItems = [
  {
    title: '《长安十二时辰》番外篇',
    desc: '马伯庸宇宙最新力作，古装悬疑巨制，豆瓣高分推荐。原班人马回归，带你重回大唐风云。',
    tag: '古装悬疑',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20of%20ancient%20Chinese%20imperial%20city%20at%20dusk%2C%20traditional%20architecture%20with%20warm%20lantern%20lighting%2C%20dramatic%20clouds%20in%20sky%2C%20mysterious%20atmosphere%2C%20historical%20drama%20aesthetic%2C%20golden%20and%20deep%20red%20color%20palette%2C%20widescreen%20cinematic%20composition%2C%20epic%20scale&width=900&height=500&seq=carousel-01-2026&orientation=landscape',
    alt: '长安十二时辰番外篇 - 古装悬疑剧',
  },
  {
    title: '《首尔告白》都市爱情',
    desc: '治愈系韩剧新标杆，跨越国界的浪漫故事。当北京遇见首尔，两个灵魂的温柔碰撞。',
    tag: '韩剧热播',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20romantic%20scene%20in%20a%20cozy%20Seoul%20cafe%20at%20night%2C%20warm%20interior%20lighting%2C%20two%20people%20silhouettes%20by%20window%2C%20city%20lights%20visible%20outside%2C%20autumn%20atmosphere%2C%20soft%20focus%2C%20emotional%20mood%2C%20burgundy%20and%20cream%20color%20tones%2C%20cinematic%20photography&width=900&height=500&seq=carousel-02-2026&orientation=landscape',
    alt: '首尔告白 - 韩剧都市爱情',
  },
  {
    title: '《深海密码》悬疑大剧',
    desc: '年度最烧脑原创剧本，深海科考队遭遇神秘事件。12集紧凑剧情，每一层反转都让人拍案。',
    tag: '国产新剧',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20sea%20research%20station%20interior%2C%20blue%20teal%20ambient%20lighting%2C%20scientists%20at%20consoles%2C%20suspenseful%20atmosphere%2C%20futuristic%20equipment%2C%20dramatic%20shadows%2C%20cinematic%20thriller%20aesthetic%2C%20wide%20angle&width=900&height=500&seq=carousel-03-2026&orientation=landscape',
    alt: '深海密码 - 悬疑原创剧',
  },
  {
    title: '《山河故人》家族史诗',
    desc: '跨越三代人的家国情怀，史诗级年代大剧。豆瓣9.2分神作，每集都是一部电影。',
    tag: '经典剧集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20family%20scene%20in%201980s%20China%2C%20traditional%20courtyard%20house%2C%20warm%20sunset%20lighting%2C%20multi%20generation%20gathering%2C%20vintage%20aesthetic%2C%20emotional%20warm%20atmosphere%2C%20golden%20hour%2C%20epic%20family%20saga&width=900&height=500&seq=carousel-04-2026&orientation=landscape',
    alt: '山河故人 - 家族史诗剧',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            编辑精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选高分好剧，每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500 text-white whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}